<template>
    <div class="bg">
        <vueHeader></vueHeader>

        <div class="banner"><span>医疗产品</span></div>

        <div class="wrap product">
            <div class="productMenu">
                <ul class="productList">
                    <li class="productItem" :class="{'active':classify==pindex}" v-for="(pitem,pindex) in product" :key="pindex">
                        <div class="itemTitle" @click="open(pindex)">
                            <img :src="classify==pindex?pitem.active:pitem.img" />
                            <span class="name" :class="{small:pitem.classify.length>6}">{{pitem.classify}}</span>
                            <!-- <span class="go">&gt;</span> -->
                            <img class="go" src="./../assets/img/product/right.png" alt="">
                        </div>
                        <div class="showClassify" v-if="pitem.name.length>0">
                            <ul class="itemList">
                                <li :class="{'active':productId==item.id}" v-for="(item,index) in pitem.name" :key="index" @click="choose(item.id)">{{item.title}}</li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="productShow">
                <router-view :list='list'></router-view>
            </div>
        </div>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            classify: 0,
            productId: -1,
            list: [],
            product: [
                {
                    classify: '全部',
                    img: require('./../assets/img/product/icon-all-1.png'),
                    active: require('./../assets/img/product/icon-all-2.png'),
                    list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                    name: []
                },
                {
                    classify: '手术室气管',
                    img: require('./../assets/img/product/icon-1-1.png'),
                    active: require('./../assets/img/product/icon-1-2.png'),
                    list: [0, 1, 2, 3, 4],
                    name: [
                        {
                            id: 0,
                            title: '普通插管'
                        },
                        {
                            id: 1,
                            title: '特殊插管'
                        },
                        {
                            id: 2,
                            title: '可冲洗插管'
                        },
                        {
                            id: 3,
                            title: '气管切开插管'
                        },
                        {
                            id: 4,
                            title: '其他附件'
                        },
                    ]
                },
                {
                    classify: 'CRRT',
                    img: require('./../assets/img/product/icon-2-1.png'),
                    active: require('./../assets/img/product/icon-2-2.png'),
                    list: [5, 6],
                    name: [
                        {
                            id: 5,
                            title: '机器'
                        },
                        {
                            id: 6,
                            title: '耗材'
                        },
                    ]
                },
                {
                    id: 7,
                    img: require('./../assets/img/product/icon-3-1.png'),
                    active: require('./../assets/img/product/icon-3-2.png'),
                    classify: '预防血栓系列',
                    list: [7],
                    name: [],
                },
                {
                    id: 8,
                    img: require('./../assets/img/product/icon-4-1.png'),
                    active: require('./../assets/img/product/icon-4-2.png'),
                    classify: '喉镜系列',
                    list: [8],
                    name: []
                },
                {
                    id: 9,
                    img: require('./../assets/img/product/icon-5-1.png'),
                    active: require('./../assets/img/product/icon-5-2.png'),
                    classify: '呼吸回路系列',
                    list: [9],
                    name: []
                },
                {
                    id: 10,
                    img: require('./../assets/img/product/icon-6-1.png'),
                    active: require('./../assets/img/product/icon-6-2.png'),
                    classify: '脑部与区域血氧检测系统',
                    list: [10],
                    name: []
                },
                {
                    id: 11,
                    img: require('./../assets/img/product/icon-7-1.png'),
                    active: require('./../assets/img/product/icon-7-2.png'),
                    classify: 'Floton福通系列呼吸机',
                    list: [11],
                    name: []
                }
            ]
        }
    },

    watch: {
        '$route': function () {
            let _this = this;
            if (this.$route.query.id >= 0) {
                this.list = [_this.$route.query.id];
            } else if (this.$route.query.product > 0) {
                this.list = this.product[_this.$route.query.product].list;
            } else {
                this.list = this.product[0].list;
            }
        }
    },

    mounted() {
        // $('.itemList').slideToggle(500);
        let _this = this;
        window.scrollTo(0, 0);
        if (this.$route.query.id >= 0) {
            this.list = [_this.$route.query.id];
        } else if (this.$route.query.product > 0) {
            this.list = this.product[_this.$route.query.product].list;
        } else {
            this.list = this.product[0].list;
        }
    },

    methods: {
        open(index) {
            this.classify = index;

            this.list = this.product[index].list;
            console.log(this.list);

            if (index == 1) {
                $('.productItem').eq(index).find('.itemList').slideDown(500);
                $('.productItem').eq(2).find('.itemList').slideUp(500);
            } else if (index == 2) {
                $('.productItem').eq(index).find('.itemList').slideDown(500);
                $('.productItem').eq(1).find('.itemList').slideUp(500);
            } else {
                $('.productItem').eq(2).find('.itemList').slideUp(500);
                $('.productItem').eq(1).find('.itemList').slideUp(500);
            }

            this.$router.replace({ path: '/product', query: { product: index } })
            // $('.productItem').eq(index * 1 + 1).find('.itemList').slideToggle(500);
        },

        choose(id) {
            // this.$store.commit('changeId', index);
            this.productId = id;
            this.$router.replace({ path: '/product', query: { id: id } })
        }
    },

    computed: {
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/product.less";
</style>


// WEBPACK FOOTER //
// src/views/product.vue